import { createContext } from "react";

import type { IMagicFeedbackContextValue } from "./MagicFeedbackProvider.types";

const MagicFeedbackContext = createContext<IMagicFeedbackContextValue | null>(null);

export { MagicFeedbackContext };
